<template>
  <div class="tender-block none-m">
    <div v-if="publicTenderInfo.description" class="d-contents">
      <h2 class="h2">{{ $t('Description') }}</h2>
      <p class="p">{{ publicTenderInfo.description }}</p>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'DescriptionOfPublicTender',
    computed: {
      ...mapState('publicTender', ['publicTenderInfo']),
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/pages/public-tender';
</style>
